var PickingColliderType = (function () {
    function PickingColliderType() {
    }
    return PickingColliderType;
}());
export { PickingColliderType };
